import { render, staticRenderFns } from "./BlocoInformacoesAdicionaisMonitoramento.vue?vue&type=template&id=5b3163ec&scoped=true&lang=pug"
import script from "./BlocoInformacoesAdicionaisMonitoramento.vue?vue&type=script&lang=js"
export * from "./BlocoInformacoesAdicionaisMonitoramento.vue?vue&type=script&lang=js"
import style0 from "./BlocoInformacoesAdicionaisMonitoramento.vue?vue&type=style&index=0&id=5b3163ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3163ec",
  null
  
)

export default component.exports